
import { SET_SHOPPING_LIST } from '../actions/set_shopping_list';
import { 
        SL_MOD_RECIPES_SUCCESS, SL_ADD_ITEMS_SUCCESS, SL_ADD_ITEMS_FAILURE, 
        SL_ADD_ITEMS_BEGIN, SL_ADD_ITEMS_CLEAR_STATUS, SL_UPD_ITEM_BEGIN,
        SL_UPD_ITEM_SUCCESS, SL_UPD_ITEM_FAILURE                 
      } from '../actions/shop_list_actions';

export default function (state = {shop_list: null, add_items_open: false, addItemsError: '', updItemsError: ''}, action) {
  switch (action.type) {

    case SET_SHOPPING_LIST:
      return {
        ...state,
        shop_list: action.payload
      }

    case SL_MOD_RECIPES_SUCCESS:
      return {
        ...state, 
        shop_list: action.payload.data.Data
      };

    case SL_ADD_ITEMS_BEGIN:
      return {
        ...state, 
        addItemsError: ''
      };

    case SL_ADD_ITEMS_CLEAR_STATUS:
      return {
        ...state, 
        addItemsError: ''
      };

    case SL_ADD_ITEMS_SUCCESS:
      return {
        ...state, 
        add_items_open: false, 
        shop_list: action.payload.data.Data
      };

    case SL_ADD_ITEMS_FAILURE:
      return {
        ...state, 
        addItemsError: 'Unable to add items'
      };
  
      case SL_UPD_ITEM_BEGIN:
        return {
          ...state, 
          updItemsError: ''
        };
    
      case SL_UPD_ITEM_SUCCESS:
        return {
          ...state, 
          shop_list: action.payload.data.Data
        };
  
      case SL_UPD_ITEM_FAILURE:
        return {
          ...state, 
          updItemsError: 'Unable to update items'
        };

        default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/shop_list_reducer.js